export const onRowDataUpdatedEvent = ({ params, onRowDataUpdated }) => {
  if (onRowDataUpdated) onRowDataUpdated(params);
};